import React from "react";
import {
  ComingSoonContainer,
  ComingSoonBody,
  ComingSoonImageContainer,
  ComingSoonImage,
  CircleImage,
  Background,
  ArticleTitle,
} from "./ComingSoon.styles";
import { CIRCLES, COMING_SOON_IMAGE } from "../../image-links";
import { ARTICLES_TEXT, ARTICLES_TITLE } from "../../text";

const ComingSoon = () => {
  return (
    <>
      <ComingSoonContainer>
        <ArticleTitle>{ARTICLES_TITLE}</ArticleTitle>
        <CircleImage src={CIRCLES} alt="three-yellow-circles" />
        <ComingSoonBody>{ARTICLES_TEXT}</ComingSoonBody>
        <ComingSoonImageContainer>
          <ComingSoonImage src={COMING_SOON_IMAGE} alt="coming_soon_image" />
        </ComingSoonImageContainer>
        <Background />
      </ComingSoonContainer>
    </>
  );
};

export default ComingSoon;
